export const MAX_IMO_LIST_SIZE = 1000;

export interface ParsedImoList {
  valid: string[];
  invalid: string[];
  truncated: boolean;
}

const IMO_TOKEN_RE = /^(?:IMO)?\d{7}$/i;

export function parseImoInput(raw: string): ParsedImoList {
  const tokens = raw
    .split(/[\s,;]+/)
    .map((token) => token.trim())
    .filter(Boolean);
  const seen = new Set<string>();
  const valid: string[] = [];
  const invalid: string[] = [];
  for (const token of tokens) {
    if (IMO_TOKEN_RE.test(token)) {
      const digits = token.replace(/^imo/i, "");
      if (!seen.has(digits)) {
        seen.add(digits);
        valid.push(digits);
      }
    } else {
      invalid.push(token);
    }
  }
  return {
    valid: valid.slice(0, MAX_IMO_LIST_SIZE),
    invalid,
    truncated: valid.length > MAX_IMO_LIST_SIZE,
  };
}

// The api checks every recipient with class-validator IsEmail (validator.js
// isEmail), so this refuses what the server refuses in the common cases: one
// @, no spaces, a domain of non-empty dot-separated parts (so no leading,
// trailing or doubled dot) ending in a top-level part of 2 or more letters.
// "a@b.c" is refused here rather than by a failed send.
const EMAIL_RE = /^[^\s@]+@(?:[^\s@.]+\.)+[A-Za-z]{2,}$/;

export const INVALID_EMAIL_MESSAGE =
  "Enter a valid email address, for example name@company.com.";

export function isValidEmail(value: string): boolean {
  return EMAIL_RE.test(value);
}
